import classNames from 'classnames';

type JobOfferFormRequestProps = {
	readonly className?: string;
};

const classNameComponent = 'c-cnm-job-offer-form-request';

export const JobOfferFormRequest = ({ className }: JobOfferFormRequestProps) => {
	const wrapperClassName = classNames(classNameComponent, className);

	return <section className={wrapperClassName}>Form</section>;
};
